import { Pipe, PipeTransform } from '@angular/core';

// Il DB salva "ug/l" (ASCII puro, per evitare problemi di encoding nella pipeline Excel/CSV);
// qui mostriamo il simbolo micro corretto solo a video, senza toccare il dato.
@Pipe({
  name: 'unitaMisura'
})
export class UnitaMisuraPipe implements PipeTransform {
  transform(unitaMisura: string): string {
    return unitaMisura === 'ug/l' ? 'µg/l' : unitaMisura;
  }
}
